export const SET_LOADING_DATA = '@promotionKitReport/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@promotionKitReport/SET_LOADING_SELECTS';

export const GET_LIST_ALL_PROMOTION_KIT_REPORTS_REQUEST =
  '@promotionKitReport/GET_LIST_ALL_PROMOTION_KIT_REPORTS_REQUEST';
export const GET_LIST_ALL_PROMOTION_KIT_REPORTS_SUCCESS =
  '@promotionKitReport/GET_LIST_ALL_PROMOTION_KIT_REPORTS_SUCCESS';

export const GET_LIST_SELECTS_REQUEST = '@promotionKitReport/GET_LIST_SELECTS_REQUEST';
export const GET_LIST_SELECTS_SUCCESS = '@promotionKitReport/GET_LIST_SELECTS_SUCCESS';

export const SHARE_CSV = '@promotionKitReport/SHARE_CSV';

export const SET_PAGE = '@promotionKitReport/SET_PAGE';
export const SET_ROWS_COUNT = '@promotionKitReport/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@promotionKitReport/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@promotionKitReport/SET_ORDER';
export const SET_ORDERBY = '@promotionKitReport/SET_ORDERBY';
